import arraySort from 'array-sort'
import { getTruncatedString } from './string'

const mapLevels = (arr, truncatedLength) => {
  const values = arr.map(function (level) {
    let labelString = `${level.mastery ? 'Mastery Level' : level.number}: ${
      level.name
    }`
    return {
      id: level.id,
      value: level.id,
      label: getTruncatedString({
        val: labelString,
        len: truncatedLength
      }),
      sort: level.sort_order
    }
  })
  return arraySort(values, ['sort'])
}

export { mapLevels }



// WEBPACK FOOTER //
// ./src/utils/levels.js